import axios from 'axios';

const defaultState = {
  organizations: []
};

export default {
  namespaced: true,

  state: {
    organizations: [],
    organizationLoading: false
  },

  mutations: {
    setOrganizations(state, data) {
      state.organizations = data;
    },

    setOrganizationLoading(state, isloading) {
      state.organizationLoading = isloading;
    },

    resetState(state) {
      Object.assign(state, defaultState);
    }
  },

  actions: {
    fetchOrganizations({ commit, dispatch }) {
      return axios.get(process.env.VUE_APP_API_URL + 'organizations')
      .then(({ data }) => {
        commit('setOrganizations', data || []);
      })
      .catch(({ response }) => dispatch('handleResponse', response, { root: true }));
    },

    deleteOrganization({ commit, state }, organizationID) {
      return axios.delete(process.env.VUE_APP_API_URL + 'organizations/' + organizationID)
      .then(() => {
        let organizations = [ ...state.organizations ];
        organizations = organizations.filter(org => org.uuid !== organizationID);
        commit('setOrganizations', organizations);
      });
    }
  }
};